import { useTranslation } from "react-i18next";
import { getDisplayDatetime } from "../../helpers/display_help";
import { Fragment, useState } from "react";
import { Button } from "reactstrap";
import { RemarkField } from "./RemarkField";

function AdminCompanyRow(props) {
    const { t } = useTranslation();
    const [isCollapse, setCollapse] = useState(true);
    const data = props.data;

    return (
        <Fragment>
            <tr onClick={() => { setCollapse(!isCollapse); }}>
                <td className="fw-medium collapse-icon">
                    {isCollapse ? <i className="bx bxs-plus-square"></i> : <i className="bx bxs-minus-square"></i>}
                </td>
                <td className="fw-medium">{data["id"]}</td>
                <td>{data["name"]}</td>
                <td>{data["system_type"]}</td>
                <td>{data["website_version"]}</td>
                <td>{data["is_enabled"] ? t('PageAdmin.CompanyStatus.Normal') : t('PageAdmin.CompanyStatus.Stopped')}</td>
                <td>{getDisplayDatetime(data["created_at"] * 1000)}</td>
                <td>{getDisplayDatetime(data["updated_at"] * 1000)}</td>
                <td style={{padding: "0.51rem 0.6rem"}}>
                    <Button className="btn-sm btn-primary" onClick={(e) => { e.stopPropagation(); props.onClickModify();}}>{t('Common.Btn.Modify')}</Button>
                    <Button className="btn-sm btn-primary" style={{ marginLeft: "10px" }} onClick={(e) => { e.stopPropagation(); props.onSelectedSimCompany(data["id"]);}}>{t('PageAdmin.Tab.SimCard')}</Button>
                    <Button className="btn-sm btn-primary" style={{ marginLeft: "10px" }} onClick={(e) => { e.stopPropagation(); props.onSelectedDeviceCompany(data["id"]);}}>{t('PageAdmin.Tab.Device')}</Button>
                </td>
            </tr>
            {isCollapse ? null :
                <tr>
                    <td></td>
                    <td colSpan="10">
                        <div className='d-flex flex-row align-items-center'>
                            <div className="input-group d-flex flex-row">
                                <span className="input-group-text col-xs-6 col-md-2" id="inputGroup-sizing-default">{t('PageAdmin.CompanyTable.Contact')}</span>
                                <span type="text" className="form-control col-6">{data["contact"]}</span>
                            </div>
                        </div>
                        <div className='d-flex flex-row align-items-center'>
                            <div className="input-group d-flex flex-row">
                                <span className="input-group-text col-xs-6 col-md-2" id="inputGroup-sizing-default">{t('PageAdmin.CompanyTable.UserManual')}</span>
                                <span type="text" className="form-control col-6">{data["user_manual"]}</span>
                            </div>
                        </div>
                        <div className='d-flex flex-row align-items-center'>
                            <div className="input-group d-flex flex-row">
                                <span className="input-group-text col-xs-6 col-md-2" id="inputGroup-sizing-default">{t('PageAdmin.CompanyTable.Remark')}</span>
                                <div className="position-relative flex-grow-1">
                                    <RemarkField remark={data["remark"]} />
                                </div>
                            </div>
                        </div>

                    </td>
                </tr>}
        </Fragment>
    );
}

export default AdminCompanyRow;